import { Link } from '../../../../../../components/atoms/link/link';
import { useReportContext } from '../../../../renderer/report-context';

interface IReadMoreLinkProps {
  readonly answer: string;
  readonly wasTruncated: boolean;
  readonly linkTo?: string;
}

const isExternalLink = (url: string): boolean => {
  return url.startsWith('http://') || url.startsWith('https://');
};

export const ReadMoreLink = ({ answer, wasTruncated, linkTo }: IReadMoreLinkProps) => {
  const { navigateToPath } = useReportContext();

  if (!answer || !wasTruncated || !linkTo) {
    return null;
  }

  const handleClick = () => {
    if (isExternalLink(linkTo)) {
      window.open(linkTo, '_blank', 'noopener,noreferrer');
    } else {
      navigateToPath(linkTo);
    }
  };

  return (
    <Link asChild onClick={handleClick}>
      <span className="underline cursor-pointer ml-1">Read More</span>
    </Link>
  );
};
